import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=2ca31d3a&scoped=true&"
import script from "./CommentCard.vue?vue&type=script&lang=js&"
export * from "./CommentCard.vue?vue&type=script&lang=js&"
import style0 from "./CommentCard.vue?vue&type=style&index=0&id=2ca31d3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca31d3a",
  null
  
)

export default component.exports